module.exports = __webpack_public_path__ + "static/media/img_1.1296af9d.png";